import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import calendar from 'dayjs/plugin/calendar';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(utc)
dayjs.extend(calendar);
dayjs.extend(advancedFormat);
export default dayjs;